import Mutations from '../../odata/mutations';

export default { ...new Mutations('xmlAudit'), ...new Mutations('xmlAudits') };
